import React, { useContext } from "react";
import { UserContext } from "../contexts/UserContext";
import Avatar from "../assets/icons/Avatar.svg";
import IconNotification from "./icons/iconNotification";
import ArrowBack from "../assets/icons/arrowBack.svg";
import { useNavigate, useLocation } from "react-router-dom";

const AgentHeader = ({ notification }) => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname.includes("home");
  const Pathname = location.pathname.includes("home")
    ? "similation"
    : location.pathname.includes("detailuser")
    ? "Détails client"
    : "";
  const userRole = user?.user?.role
  const handleLogoRedirect = () => {
    const homePaths = {
        "admin": "/admin-home",
        "super-admin": "/super-admin-home",
        "super-agent": "/super-agent-home",
        "agent": "/agent-home",
        "marketing": '/marketing-home'
    };
    navigate(homePaths[userRole]);
  };

  return (
    <div className="flex justify-between w-full items-start my-[24px] ">
      <h1 className=" flex-col items-start font-medium hidden lg:flex">
        Welcome Back,{" "}
        {user.user.firstName.charAt(0).toUpperCase() +
          user.user.firstName.slice(1)}
        {isHome && (
          <span className="text-[16px] text-[#A5A5A5] font-normal">
            Voici les informations concernant toutes vos opérations
          </span>
        )}{" "}
      </h1>
      <h1 className="flex items-center justify-between w-full gap-5 lg:hidden text-[20px] font-bold">
          <img className="cursor-pointer" onClick={handleLogoRedirect} src={ArrowBack} width={24} height={24} alt="" />
        {Pathname}
        <div className="w[24px]" />
      </h1>
      <div className="hidden lg:flex items-center gap-3">
        {/* <IconNotification className="mr-4" isNotification={notification > 0} /> */}

        <img src={Avatar} width={32} height={32} alt="" />
        <div className="flex flex-col leading-4 items-start">
          <h2 className="text-[16px] font-normal">
            {user.user.firstName} {user.user.lastName}
          </h2>
          {/* <span className='text-[#000000]/30 text-[12px]'>{user.user.role}</span> */}
        </div>
      </div>
    </div>
  );
};

export default AgentHeader;
